// extracted by mini-css-extract-plugin
export default {"full":"List_full__jRV+h","item":"List_item__YRc0r","item_broker":"List_item_broker__WfIMM","details":"List_details__toMwt","text":"List_text__jRcb6"};